<!--线路  -->
<script setup>
import {exchangeOrderRate} from '@/utils/index'

import {getPostageRouteAPI} from '@/apis/order'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore()
const props=defineProps(['orderNo','orderType'])
const emits=defineEmits('setPostage')
const LineList=ref([])
//获取全部线路
const getLineList=async ()=>{
    console.log('编号',props.orderNo)
    console.log('orderType',props.orderType)
    const res = await getPostageRouteAPI({order_no:props.orderNo,order_type:props.orderType})
    if(res.code==0){
        console.log(res.data.list)
        LineList.value=res.data.list
       if(LineList.value.length>0){
        handleChange(LineList.value[0].route_id)
       }
      
    }
}
const lineType=ref()
const handleChange=(value)=>{
    
    const result = LineList.value.find(item => item.route_id === value);
    console.log('切换线路值',result)
    lineType.value=value
    emits('setPostage',result)
}
const isMobile = ref(false);
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    getLineList()
})
</script>
<template>
    <div style="width: 100%;">
    <div class="line" v-if="isMobile==false">
        <div class="lineTop"  >
               <div class="address-title">{{ $t('setup473') }}</div>
        </div>
        <div class="lineList custom-scrollbar" v-if="isMobile==false" >
            <el-scrollbar max-height="422px">
            <el-radio-group v-model="lineType" v-bind="$attrs" @change="handleChange" style="align-items: flex-start;flex-wrap: wrap;
            font-size: 0;display: flex;flex-direction: column;">
            <!-- {{ LineList }} -->
            <div v-for="(line,i) in LineList" :key="i" class="list">
                <el-radio :label="line.route_id" style="height: 224px;width: 100%;">
                    <div class="labelList ">
                        <div style="display: flex">
                            <div class="lineNameImg flexcolumn">
                                <img :src="line.img" alt="" style="width: 80px; height: 80px;border-radius: 50%;object-fit: cover;"> 
                                <div class="name">{{ line.name }}</div> 
                                <div class="aboutflex">
                                    <div class="insured HorizontalCenter">{{ $t('setup479') }}</div>
                                    <div class="free HorizontalCenter">{{ $t('setup478') }}</div>
                                </div>
                            </div>
                            <div class="fee">
                                    <div class="lable">{{ $t('setup474') }}</div>
                                    <div class="price"> {{exchangeOrderRate(line.postage,userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate) }}</div>
                                    <div class="annotate">{{ $t('setup475') }}</div>
                                    <div class="lable">{{ $t('setup476') }}</div>
                                    <div class="days">{{line.min_transport_time}}-{{line.max_transport_time}}<span>{{ $t('setup477') }}</span></div>
                            </div>
                        </div>
                        <div class="description">
                            {{ line.description }}
                        </div>
                    </div>
                   
                </el-radio>
            </div>
                
            </el-radio-group>
            </el-scrollbar>
        </div>
    </div>
    <div v-else class="phoneline">
        <el-scrollbar max-height="333px">
            <div class="lineList">
                <div class="lineitem" v-for="(line,i) in LineList" :key="i" >
                    <!-- -->
                        <div style="display: flex;justify-content: space-between;">

                    
                        <div class="item">
                            <div class="lineNameImg">
                                <div><img :src="line.img" alt="" style="width: 60px; height: 60px;border-radius: 50%;object-fit: cover; "> </div>
                                <div class="lineName">
                                    <div class="name">{{ line.name }}</div>
                                    <div style="display: flex;"> 
                                        <div class="insured HorizontalCenter">{{ $t('setup479') }}</div>
                                        <div class="free HorizontalCenter">{{ $t('setup478') }}</div>
                                    </div> 
                                </div>
                            </div>
                            <div class="aboutflex" style="padding-top: 15px;"><div class="lable" >{{ $t('setup474') }}</div><div class="value" style="color: #FC3938;"> {{exchangeOrderRate(line.postage,userStore.exchangeRate.symbol, userStore.exchangeRate.currency, userStore.exchangeRate.rate) }}</div></div>
                            <div class="aboutflex" style="padding-top: 15px;"><div class="lable">{{ $t('setup476') }}</div><div class="value">{{line.min_transport_time}}-{{line.max_transport_time}}<span>{{ $t('setup477') }}</span></div></div>
                        </div>
                        <div @click="handleChange(line.route_id)">
                            <img style="width: 16px;height: 16px;" src="../../assets/images/check.png" alt="" srcset="" v-if="lineType== line.route_id">
                            <img style="width: 16px;height: 16px;" src="../../assets/images/nocheck.png" alt="" srcset="" v-else >
                        </div>
                    </div>
                    <!-- -->
                </div>
            </div>
        </el-scrollbar>
    </div>
</div>
</template>
<style scoped lang="scss">

.line{
    width: 1200px;
    height: auto;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px 20px;
    margin: auto;

    .lineTop{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 17px;
            .address-title{
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 18px;
            color: #11192D;
            line-height: 24px;
            text-align: left;
            font-style: normal;
        }
    }
    .lineList{
        height: 422px;
        width: 100%;
        overflow-y: scroll;
       
        .list{
            width: 100%;
            // border-bottom: 1px solid #F1F3F5;

            .labelList{
                display: flex;
                padding-top: 30px;
                padding-bottom: 50px;
            }
           
        }
        .list:not(:last-child) {
        border-bottom: 1px solid #F1F3F5;
        }
        .lineNameImg{
           .name{
            font-family: MicrosoftYaHei;
            font-size: 18px;
            color: #333333;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            padding-top: 11px;
            padding-bottom: 8px;
           } 
           .insured{
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #FF9845;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            height: 24px;
            background: #FFF1EB;
            border-radius: 12px;
            padding:0 15px;
            margin-right: 8px;
           }
           .free{
            padding:0 15px;
            height: 24px;
            background: #E5FFF4;
            border-radius: 12px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #148A55;
            line-height: 16px;
            text-align: left;
            font-style: normal;
           }
        }
        .fee{
            width: 352px;
            margin-left: 80px;
            // margin-right: 50px;
            .lable{
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #888888;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                padding-bottom: 11px;
            }
            .price{
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 22px;
                color: #FC3938;
                line-height: 22px;
                text-align: left;
                font-style: normal;
            }
            .annotate{
                padding: 10px 0 25px 0;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #888888;
                line-height: 12px;
                text-align: left;
                font-style: normal;
            }
            .days{
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 22px;
                color: #333333;
                line-height: 18px;
                text-align: left;
                font-style: normal; 
                span{
                    font-size: 12px;
                }
            }
        }
        .description{
            width: 435px;
height: 160px;
            font-family: MicrosoftYaHei;
            font-size: 10px;
            color: #888888;
            line-height: 16px;
            text-align: left;
            font-style: normal;
            overflow-wrap: break-word;/* 现代标准属性 */
            white-space: pre-wrap;
            /* 兼容性处理 */
    -webkit-hyphens: auto;    /* Safari 断字 */
    hyphens: auto; 
        }
    }
}
@media (max-width: 768px) {
    .phoneline{
        background: #FFFFFF;
        box-shadow: 0px 4px 20px 6px rgba(237,237,237,0.75);
        border-radius: 8px;
        width: 100%;
        .lineList{
            height: 333px;
            overflow-y: scroll;
            width: 100%;
            padding: 0 15px;
            .lineitem{
                padding-top: 20px;
                padding-bottom: 20px;
                width: 100%;
                // display: flex;
                // justify-content: space-between;
                .item{
                   .lable{
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #888888;
                    line-height: 14px;
                    text-align: left;
                    font-style: normal;
                   }
                   .value{
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    font-size: 14px;
                    color: #333333;
                    line-height: 14px;
                    text-align: left;
                    font-style: normal;

                   }
                    .lineNameImg{
                        display: flex;
                        padding-bottom: 8px;
                    }
                    .lineName{
                       margin-left: 10px;
                        width: 210px;
                       
                        .name{
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 600;
                            font-size: 18px;
                            color: #333333;
                            line-height: 25px;
                            text-align: left;
                            font-style: normal;
                            padding-top: 4px;
                            padding-bottom: 5px;
                        } 
                        .insured{
                            font-family: MicrosoftYaHei;
                            font-size: 12px;
                            color: #FF9845;
                            line-height: 16px;
                            text-align: left;
                            font-style: normal;
                            height: 24px;
                            background: #FFF1EB;
                            border-radius: 12px;
                            padding:0 15px;
                            margin-right: 8px;
                        }
                        .free{
                            padding:0 15px;
                            height: 24px;
                            background: #E5FFF4;
                            border-radius: 12px;
                            font-family: MicrosoftYaHei;
                            font-size: 12px;
                            color: #148A55;
                            line-height: 16px;
                            text-align: left;
                            font-style: normal;
                        }
                    }
                   
                }

            }
        }
    }
}
</style>